export default __webpack_public_path__ + "static/solving_problems_through_code-cc6cd50d79a878a860459af5fe04f5f4.jpg";